import { IApiResult, IDayResult, IResult } from './IResult'
import moment from 'moment'

class Transformer {
    static transform (data: IApiResult): IResult {

        let vatPercentages: number[] = []
        const dayResults: IDayResult[] = []

        for (const apiDayResult of data.result) {
            dayResults.push({
                date: moment(apiDayResult.date),
                total: apiDayResult.total,
                vatPercentages: apiDayResult.vat_percentages
            })

            vatPercentages = [
                ...vatPercentages,
                ...Object.keys(apiDayResult.vat_percentages).map((vatPercentage) => parseFloat(vatPercentage))
            ]
        }

        return {
            vatPercentages: [...new Set(vatPercentages)].sort((a, b) => b - a),
            dayResults: dayResults.sort((dayResultsA, dayResultsB) => {
                return moment(dayResultsA.date).diff(dayResultsB.date, 'days')
            })
        }
    }
}

export default Transformer
